import { createStore } from 'satcheljs';
import { MailSignatureCloudSettings } from './schema/MailSignatureCloudSettings';

const initialState: MailSignatureCloudSettings = {
    roamingNewSignatureHTML: null,
    roamingReplySignatureHTML: null,
};

export const getMailSignatureCloudSettingsStore = createStore(
    'mailSignatureCloudSettings',
    initialState
);
